<template>
    <div class="operator-bar-wrapper clr">
        <div class="opeat-l">
            <RoundButton @btnClick="addQuestionHandler" :text="addQuestion"></RoundButton>
            <RoundButton @btnClick="importHandler" :text="importText"></RoundButton>
            <RoundButton class="btn-export" :text="exportBtn" :icon="exportIcon" :hoverIcon="exportIconHover" @btnClick="exportClick" />
        </div>
        <div class="opeat-r opeate-content" v-show="!isFirstScene">
            <LangSelect :value="initLang" class="lang-select" @change="langChange" :requireAll="true"></LangSelect>
            <Select :initValue="initRecommend" :options="recommendOptions" class="recommend-select" @menuClick="recommendChange" />
            <Select :initValue="initStatus" :options="statusOptions" class="status-select" @menuClick="statusChange" />
            <Select :initValue="initCreator" :options="questionCreators" class="creator-select" @menuClick="creatorChange" />
            <Search :hasInput="true" :placeholder="placeholder" class="question-search" @searchChange="searchChange" @inputChange="searchChange">
                <Select
                    :initValue="QuestionType"
                    :options="questionOptions"
                    class="question-select"
                    slot="right"
                    @menuClick="questionTypeChange"
                    :topOrBottom="40"
                />
            </Search>
            <Select :initValue="langType" :options="conditionOption" class="include lang-select" @menuClick="conditionChange" />
            <Select :initValue="initSmallLang" :options="smallLangOption" class="lang-select lang-select-right" @menuClick="smallLangChange" />
        </div>
    </div>
</template>

<script>
import Search from "@/views/zhiji/bComponents/inputs/Search";
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import Select from "@/views/zhiji/bComponents/inputs/Select";
import BatchImport from "./BatchImport";
import QuestionEditModal from "@/views/zhiji/components/questionEdit/QuestionEditModal";
import LangSelect from "@/components/langSelect";
import { statusOptions, creatorOptions, questionOptions, recommendOptions, smallLangOption, conditionOption } from "../pageConfig.js";
import { debounce } from "@/views/zhiji/js/common/util.js";

export default {
    name: "OperationBar",
    props: ["data", "row", "standTotal"],
    components: {
        Search,
        RoundButton,
        Select,
        LangSelect
    },
    data() {
        return {
            QuestionType: "stand",
            pageOne: 1,
            langType: conditionOption()[0].value,
            smallLang: "",
            exportIcon: "url(" + this.zhiji.staticPath() + "class-spr.png) -66px -115px",
            exportIconHover: "url(" + this.zhiji.staticPath() + "class-spr.png) -66px -115px"
        };
    },
    mounted() {
        this.searchHanlder = debounce(data => {
            let searchField = data[0];
            this.searchQuestion(searchField);
        }, 500);
    },
    computed: {
        questionCreators() {
            let options = [...this.getStorePorp("questionCreators")];

            if (!options.length) {
                options.push(...creatorOptions());
                this.$store.dispatch("zhiji/initQuesCreators");
            }

            return options;
        },
        sceneId() {
            return this.getStorePorp("querySetting").classId;
        },
        isFirstScene() {
            const classId = this.getStorePorp("querySetting").classId;
            const isFirstSceneSelected = classId == 1 || classId == 1001;

            return isFirstSceneSelected;
        },
        statusOptions() {
            return statusOptions();
        },
        questionOptions() {
            return questionOptions();
        },
        recommendOptions() {
            return recommendOptions();
        },
        conditionOption() {
            return conditionOption();
        },
        smallLangOption() {
            return smallLangOption();
        },
        placeholder() {
            return this.$t("zhiji.common.inputHolderLabel");
        },
        addQuestion() {
            return this.$t("zhiji.knowlege.addBtnLabel");
        },
        importText() {
            return this.$t("zhiji.common.import");
        },
        querySetting() {
            return this.getStorePorp("querySetting");
        },
        initLang() {
            return this.querySetting.lang || "all";
        },
        initRecommend() {
            return this.querySetting.recommendSimilar || "all";
        },
        initStatus() {
            return this.querySetting.status || "all";
        },
        initCreator() {
            return this.querySetting.creator || "all";
        },
        initSmallLang() {
            return this.querySetting.smallLang || "all";
        },
        exportBtn() {
            return this.$t("zhiji.common.export");
        }
    },
    watch: {
        // 监控中英文切换，重新从后台取对应语言数据
        placeholder() {
            this.$store.commit("zhiji/clearCreatorOption");
            this.getQuestionList({ page: this.pageOne });
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionListPage[propName];
        },
        getQuestionList(reqData) {
            this.$store.dispatch("zhiji/queryQuestionList", reqData);
            this.$store.dispatch("zhiji/queryExtQuestionTotal", reqData);
            this.$store.dispatch("zhiji/queryAnswersTotal", reqData);
            this.$emit("initCurrPage");
        },
        importHandler() {
            this.$store.dispatch("zhiji/showModal", {
                type: BatchImport,
                data: {
                    cancel: () => {
                        this.getQuestionList({
                            page: this.pageOne
                        });
                        this.$emit("initCurrPage");
                    }
                }
            });
        },
        addQuestionHandler() {
            const classId = this.getStorePorp("querySetting").classId;

            this.$store.dispatch("zhiji/showModal", {
                type: QuestionEditModal,
                data: {
                    questionId: "",
                    sceneId: classId,
                    closeHandler: () => {
                        this.getQuestionList({
                            page: this.pageOne
                        });
                        this.$emit("initCurrPage");
                    }
                }
            });
        },
        langChange(data) {
            this.getQuestionList({
                lang: data,
                page: this.pageOne
            });
            this.$emit("initCurrPage");
        },
        recommendChange(data) {
            this.getQuestionList({
                recommendSimilar: data.value,
                page: this.pageOne
            });
            this.$emit("initCurrPage");
        },
        statusChange(data) {
            this.getQuestionList({
                status: data.value,
                page: this.pageOne
            });
            this.$emit("initCurrPage");
        },
        creatorChange(data) {
            this.getQuestionList({
                creator: data.value,
                page: this.pageOne
            });
            this.$emit("initCurrPage");
        },
        conditionChange(data) {
            this.langType = data.value;
            this.smallLang && this.queryBySmallLang();
        },
        smallLangChange(data) {
            this.smallLang = data.value;
            data.value === "all" ? (this.smallLang = "") : "";
            this.queryBySmallLang();
        },
        queryBySmallLang() {
            this.getQuestionList({
                langType: this.smallLang ? this.langType : "",
                smallLang: this.smallLang,
                page: this.pageOne
            });
            this.$emit("initCurrPage");
        },
        questionTypeChange(data) {
            this.QuestionType = data.value;
        },
        searchChange(data) {
            this.searchHanlder(data);
        },
        searchQuestion(data) {
            let searchType = this.QuestionType;
            data.value === "" ? (searchType = "") : "";

            this.getQuestionList({
                type: searchType,
                field: data.value,
                page: this.pageOne
            });
            this.$emit("initCurrPage");
        },
        exportClick() {
            if (this.sceneId && this.standTotal) {
                this.$store.dispatch("zhiji/showModal", {
                    type: "ExportFaqModal",
                    data: {
                        type: "set_id",
                        sceneId: this.sceneId
                    }
                });
            } else {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "error",
                        message:
                            this.standTotal === 0 ? this.$t("zhiji.knowlege.exportModal.noDataTips") : this.$t("zhiji.knowlege.exportModal.noScenes")
                    }
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.operator-bar-wrapper {
    .opeat-l,
    .select-opt,
    .opeat-r {
        display: inline-block;
    }

    .opeat-l,
    .opeat-r {
        font-size: 0;
        float: left;
        margin-bottom: 8px;
    }

    .lang-select,
    .status-select,
    .creator-select,
    .question-search,
    .lang-select,
    .recommend-select {
        width: 120px;
        margin-right: 8px;
        margin-bottom: 8px;
        display: inline-block;
        vertical-align: middle;
    }

    .include {
        margin-right: 0;
        border-bottom-right-radius: 0;
        border-top-right-radius: 0;
    }

    .lang-select-right {
        border-bottom-left-radius: 0;
        border-top-left-radius: 0;
        width: 185px;
    }

    .question-search {
        display: inline-flex;
    }

    .question-search {
        font-size: 12px;
        width: 318px;
    }

    .question-select {
        border: 0;
        border-right: 1px solid #e3e3e3;
        border-radius: 0;
    }
    .primary-btn.btn-export{
        position: absolute;
        top:18px;
        right: 0;
        border: 1px solid#2EC2FF !important;
        color: #2EC2FF !important;
        background: #fff !important;
        box-shadow: none;
        /deep/.round-btn-icon{
            width: 16px;
            vertical-align: -1px;
        }
    }
}
.clr {
    &:after {
        content: " ";
        clear: both;
        height: 0;
        visibility: hidden;
        display: block;
    }
}

</style>
